module.exports = __webpack_public_path__ + "img/icon_submenu12.bc74437f.svg";